import ApiSmile from '@/api/api-smile';
import ActionArea from '@/component/action-area';
import {ActionButton} from '@/component/action-area/action-area';
import DataRow from '@/component/data-row';
import PageContainer from '@/component/page-container';
import {HoldState} from '@/model/const';
import HoldUtil from '@/util/hold-util';
import LabelUtil from '@/util/label-util';
import LoadingUtil from '@/util/loading-util';
import MessageUtil from '@/util/message-util';
import Utils from '@/util/utils';
import {Form, Modal} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router';
import {HoldData} from '../types';
import './hold-detail.scss';

const HoldDetail = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<HoldData>();
    const [isEdit, setIsEdit] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if (!Utils.isPositiveInteger(id)) {
            navigate('/', {replace: true});
            return;
        }

        const load = async () => {
            LoadingUtil.show();
            const response: any = await ApiSmile.getHoldDetail(id || '');
            if (response?.data?.code === 0) {
                setData(response.data.data);
            } else {
                const msg = response?.data?.msg || '网络请求失败';
                MessageUtil.error(msg);
            }
            LoadingUtil.hide();
        };

        if (Number(id) > 0) {
            load();
        }
    }, [navigate, id]);

    const onUpdateData = () => {
        const value = form.getFieldsValue();
        const payload = {
            buyDescription: value?.buyDescription || '',
            sellDescription: value?.sellDescription || '',
        };
        const update = async () => {
            LoadingUtil.show();
            const response: any = await ApiSmile.updateHoldDetail(id || '', payload);
            if (response?.data?.code === 0) {
                setData(response.data.data);
                onCancelClick();
                MessageUtil.info('保存成功');
            } else {
                const msg = response?.data?.msg || '网络请求失败';
                MessageUtil.error(msg);
            }
            LoadingUtil.hide();
        };

        Modal.confirm({
            title: '确定更新吗？',
            content: (
                <div>
                    <div>{`买入描述：${payload.buyDescription}`}</div>
                    <div>{`卖出描述：${payload.sellDescription}`}</div>
                </div>
            ),
            onOk: update,
        });
    };

    const onSaveClick = () => {
        onUpdateData();
    };

    const onResetEdit = () => {
        setIsEdit(false);
        form.resetFields();
    };

    const onCancelClick = () => {
        onResetEdit();
    };

    const onEditClick = () => {
        setIsEdit(true);
        form.setFieldsValue(data);
    };

    const getButtons = () => {
        const buttons: ActionButton[] = [];
        if (isEdit) {
            buttons.push({text: '取消', onClick: onCancelClick});
            buttons.push({text: '保存', onClick: onSaveClick, type: 'primary'});
        } else {
            if (data) {
                buttons.push({text: '编辑', onClick: onEditClick});
            }
        }
        return buttons;
    };

    return (
        <PageContainer className="page-hold-detail">
            <ActionArea buttons={getButtons()} />
            <Form form={form}>
                <DataRow title="名称代码">{`${data?.name || ''}(${data?.code || ''})`}</DataRow>
                <DataRow title="持有状态">{LabelUtil.getHoldState(data?.holdState || '')}</DataRow>
                <DataRow title="数量">{data?.quantity || ''}</DataRow>
                <DataRow title="买入时间">{Utils.formatDate(data?.buyTime)}</DataRow>
                <DataRow title="买入价格">{Utils.formatPrice(data?.buyPrice)}</DataRow>
                <DataRow title="买入说明">
                    {isEdit ? (
                        <Form.Item name={'buyDescription'}>
                            <TextArea rows={4} className="data-desc" />
                        </Form.Item>
                    ) : (
                        data?.buyDescription || ''
                    )}
                </DataRow>
                <DataRow title="卖出时间">{data?.holdState === HoldState.SOLD ? Utils.formatDate(data.sellTime) : '--'}</DataRow>
                <DataRow title="卖出价格">{data?.holdState === HoldState.SOLD ? Utils.formatPrice(data.sellPrice) : '--'}</DataRow>
                <DataRow title="卖出说明">
                    {isEdit && data?.holdState === HoldState.SOLD ? (
                        <Form.Item name={'sellDescription'}>
                            <TextArea rows={4} className="data-desc" />
                        </Form.Item>
                    ) : data?.holdState === HoldState.SOLD ? (
                        data?.sellDescription || ''
                    ) : (
                        '--'
                    )}
                </DataRow>
                <DataRow title="收益">{HoldUtil.getProfit(data)}</DataRow>
                <DataRow title="收益率">{HoldUtil.getProfitRate(data)}</DataRow>
            </Form>
        </PageContainer>
    );
};

export default HoldDetail;
